import React, { useEffect, useState } from 'react';
import {Controller, useFormContext } from 'react-hook-form';
import { TextField, Grid, Box, Chip, FormControl, Select, MenuItem, Typography, Card, Checkbox, ListItemText, Autocomplete } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { CalendarIcon, DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BookingService } from '../../Booking/Service';
import { pattern } from '../../../components/Pattern/Pattern';
import ImageSection from './ImageSection';


const formatValue = (value) => {
  if (!value) return '';  // Return empty string instead of 0
  const numValue = parseFloat(value);
  return isNaN(numValue) ? '' : numValue.toString();
};

const getUploadedProfileImageUrl = (uploadData) => {
  const baseUrl = uploadData?.imageBaseUrl?.replace(/\/+$/, '');
  const directory = uploadData?.imageDirectory?.replace(/^\/+|\/+$/g, '');
  const imageName = uploadData?.imageName;

  if (!baseUrl || !directory || !imageName) {
    return '';
  }

  return `${baseUrl}/${directory}/md/${imageName}`;
};

const BasicInfo = () => {
  const { control, handleSubmit, setValue, formState: { errors }, watch } = useFormContext();
  const [categoryList, setCategoryList] = useState([]);
  useEffect(() => {
    const fetchCategoryList = async () => {
      try {
        const categoryListResponse = await BookingService.categoryList();
        // console.log("category list Response:",categoryListResponse);
        if (categoryListResponse.success === 1) {
          setCategoryList(categoryListResponse.data)
        }
      } catch (error) {

      }
    }
    fetchCategoryList();
  }, []);

  // profile image related
  const [trigStatus, setTrigStatus] = useState(null);
  const [imgModalOpen, setImgModalOpen] = useState(false);
 

  const closeModal = () => {
    setImgModalOpen(false);
  };
   const handlePImgTrig = (data) => {
    setTrigStatus(data);
  }
  const imgData = {
    path: "profile",
    // image_name: `img-${GenerateUniqueVal(1000000)}-${personalDetails.id}.jpeg`,
    img_type: "single"
  };
  const imgUploadResponse = (data,imageType) => {
    if (imageType === "profile") {
      const imageUrl = getUploadedProfileImageUrl(data);
      if (imageUrl) {
        setValue('image', imageUrl, { shouldDirty: true, shouldValidate: true });
      }
    }
    if (imageType === "banner") {
      // updateUserProfileImage(data, "banner");
    }
  }
  return (
    <Grid item xs={12} md={7} >
      <Card sx={{}}>
        <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
          <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Basic Info</Typography>
        </Box>
        <Grid container spacing={2} sx={{ p: '2%' }}>
          <Grid item xs={12} sm={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>First Name<span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name='firstName'
                  control={control}
                  rules={{
                    required: "required",
                    pattern: pattern.personalName,
                    // minLength: {
                    //   value: 3,
                    //   message: "minimum 3 digit"
                    // },
                    // maxLength: {
                    //   value: 30,
                    //   message: "maximum 30 digit"
                    // }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      sx={{width:{xs:'100%',sm:'auto'}}}
                      size='small'
                      InputProps={{
                        style: {
                          // height:'2rem',
                          fontSize: '.75rem'
                        },
                        // inputProps:{
                        //     style:{textTransform:"uppercase"},
                        // }   
                      }}
                      error={!!error}
                    // helperText={error && error?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Middle Name</Typography>
                <Controller
                  name='middleName'
                  control={control}
                  rules={{
                    // required: "required",
                    pattern: pattern.personalName,
                    // minLength: {
                    //   value: 3,
                    //   message: "minimum 3 digit"
                    // },
                    maxLength: {
                      value: 30,
                      message: "maximum 30 digit"
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      sx={{width:{xs:'100%',sm:'auto'}}}
                      size='small'
                      InputProps={{
                        style: {
                          // height:'2rem',
                          fontSize: '.75rem'
                        },
                        // inputProps:{
                        //     style:{textTransform:"uppercase"},
                        // }   
                      }}
                      error={!!error}
                    // helperText={error && error?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Last Name</Typography>
                <Controller
                  name='lastName'
                  control={control}
                  rules={{
                    pattern:{
                      value : /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\s'.-]{1,50}$/,
                      message: "Enter valid name (1-50 characters, letters, spaces, apostrophe, hyphen, dot allowed)"
                    }
                    // required: "required",
                    // pattern: pattern.businessName,
                    // minLength: {
                    //   value: 3,
                    //   message: "minimum 3 digit"
                    // },
                    // maxLength: {
                    //   value: 30,
                    //   message: "maximum 30 digit"
                    // }
                  }}
                  defaultValue ={'.'}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      sx={{width:{xs:'100%',sm:'auto'}}}
                      size='small'
                      InputProps={{
                        style: {
                          // height:'2rem',
                          fontSize: '.75rem'
                        },
                        // inputProps:{
                        //     style:{textTransform:"uppercase"},
                        // }   
                      }}
                      onChange={(e) => {
                        let value = e.target.value;
                        // setValue('lastName', e.target.value)
                        if (e.target.value == '') {
                          field.onChange('.')
                        }else if(value.startsWith('.')){
                          field.onChange(value.slice(1))
                        }
                        else {
                          field.onChange(e.target.value)
                        }
                      }}
                      error={!!error}
                    // helperText={error && error?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Email<span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name='email'
                  control={control}
                  rules={{
                    required: 'enter Email',
                    pattern: {
                      value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                      message: "Email is not Valid"
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      fullWidth
                      // sx={{width:'80%'}}
                      size='small'
                      InputProps={{
                        style: {
                          // height:'2rem',
                          fontSize: '.75rem'
                        },
                        // inputProps:{
                        //     style:{textTransform:"uppercase"},
                        // }   
                      }}
                      onChange={(e) => {
                        const value = e.target.value.toLowerCase();
                        field.onChange(value);
                      }}
                      error={!!error}
                    // helperText={error && error?.message}
                    />
                  )}
                />
                {/* </Box> */}
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Alternate Number </Typography>
                <Controller
                  name='mobileNumberAlt'
                  control={control}
                  rules={{
                    pattern: pattern.mobile
                  }}
                  // defaultValue={0}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      size='small'
                      fullWidth
                      // sx={{width:{xs:'100%',sm:'auto'}}}
                      error={!!error}
                      type='number'
                      placeholder='Mobile Number(optional)'

                      // Add these props to prevent increment/decrement
                      inputProps={{
                        style: { fontSize: '0.65rem' },
                        onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                        onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                        onKeyDown: (e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        let finalValue;
                        if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                          // field.onChange(formatValue(inputValue));
                          finalValue = formatValue(inputValue);
                          console.log(finalValue);
                          // Check if the value exceeds 10000 and constrain it
                          if(finalValue == 0){
                            finalValue = ''
                          }else{
                            const numValue = parseFloat(finalValue);
                            if (!isNaN(numValue) && numValue > 0) {
                              finalValue = finalValue.slice(0, 10);
                            }  
                          }                   
                          field.onChange(finalValue);
                        }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Date Of Birth<span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name="dob"
                  control={control}
                  defaultValue={dayjs().subtract(18, 'year').format('YYYY-MM-DD')}
                  rules={{
                    required: "Date of Birth is required",
                    validate: (value) => {
                      if (!value) return "This field is required";
                      const date = dayjs(value);
                      const today = dayjs().startOf('day');
                      const eighteenYearsAgo = today.subtract(18, 'year');

                      if (!date.isValid()) return "Invalid date";
                      if (date.isAfter(today)) return "Date of Birth must be in the past";
                      if (date.isAfter(eighteenYearsAgo)) return "must be at least 18 years old";

                      return true;
                    }
                  }}
                  render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        {...restField}
                        sx={{
                          '& . iconButton': {
                            padding: 0.5,
                            fontSize: '1rem'
                          }
                        }}
                        value={value ? dayjs(value) : null}
                        onChange={(newValue) => {
                          // Store the date in YYYY-MM-DD format for database compatibility
                          onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                        }}
                        format="DD-MM-YYYY" // Display format for user
                        maxDate={dayjs().subtract(18, 'year')}
                        slots={{
                          openPickerIcon: (props) => (
                            <CalendarIcon
                              {...props}
                              sx={{
                                fontSize: '1rem', // Control icon size
                                color: 'gray',    // Optional: control icon color
                                padding: 0
                              }}
                            />
                          ),
                        }}
                        slotProps={{
                          textField: {
                            error: !!error,
                            helperText: error?.message,
                            fullWidth: true,
                            // required: true,
                            size: 'small',
                            inputProps: {
                              style: { fontSize: '.75rem' }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ width: '60%', fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Gender <span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name='gender'
                  control={control}
                  rules={{ required: 'select gender' }}
                  render={({ field, fieldState: { error } }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        size='small'
                        sx={{
                          minHeight: '0px',
                          // height: '1.6rem',
                          fontSize: '0.75rem',
                          // fontWeight: '600',
                          textTransform: 'capitalize'
                        }}
                        error={!!error}
                      // helperText={error && error?.message}
                      >
                        <MenuItem sx={{ textTransform: 'capitalize' }} value='Male'>male</MenuItem>
                        <MenuItem sx={{ textTransform: 'capitalize' }} value='Female'>female</MenuItem>
                        <MenuItem sx={{ textTransform: 'capitalize' }} value={'Prefer Not To Say'}>Prefer Not To Say</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Visiting Charge <span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name='visitingCharge'
                  control={control}
                  rules={{
                    // required: 'Enter Visiting Charge',
                    // validate: (value) => {
                    //   const numValue = parseInt(value, 10);
                    //   if (isNaN(numValue)) return 'Please enter a valid Amount';
                    //   if (numValue < 0) return 'Visiting Charge should be 0 or greater than 0';
                    //   if (numValue > 900) return 'Visiting Charge cannot exceed Rs. 900';
                    //   return true;
                    // }
                  }}
                      defaultValue={0}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      size='small'
                      fullWidth
                      // sx={{width:{xs:'100%',sm:'auto'}}}
                      error={!!error}
                      type='number'
                      placeholder='0'

                      // Add these props to prevent increment/decrement
                      inputProps={{
                        style: { fontSize: '0.65rem' },
                        onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                        onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                        onKeyDown: (e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        let finalValue;
                        if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                          // field.onChange(formatValue(inputValue));
                          finalValue = formatValue(inputValue);
                          console.log("finalValue",finalValue)

                          if(finalValue==''){
                            finalValue=0
                          }else {
                            // Check if the value exceeds 10000 and constrain it
                          const numValue = parseFloat(finalValue);
                          if (!isNaN(numValue) && numValue > 900) {
                            finalValue = '900';
                          }
                          }

                          field.onChange(finalValue);
                        }
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <Grid container>
              <Grid xs={12}>
                <ImageSection  
                  imgModalOpen={imgModalOpen} 
                  setImgModalOpen={setImgModalOpen} 
                  closeModal={closeModal} 
                  imgData={imgData} 
                  imgUploadResponse={imgUploadResponse} 
                  handlePImgTrig={handlePImgTrig}
                />
              </Grid>              
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={9}>
                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Service Categories <span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name='serviceCategories'
                  control={control}
                  rules={{ required: 'select category' }}
                  defaultValue={[]}
                  render={({ field, fieldState: { error } }) => (
                    <FormControl size="small" sx={{ minWidth: "100%" }}>
                      <Select
                        {...field}
                        size='small'
                        multiple
                        renderValue={(selected) => (
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={categoryList.find(opt => opt.id.toString() === value)?.title}
                                size="small"
                                sx={{ fontSize: '.65rem' }}
                                onDelete={(event) => {
                                  event.stopPropagation();
                                  const newValue = field.value.filter(item => item !== value);
                                  field.onChange(newValue);
                                }}
                                deleteIcon={
                                  <CancelIcon onMouseDown={(event) => event.stopPropagation()} />
                                }
                              />
                            ))}
                          </Box>
                        )}
                        error={!!error}
                        onChange={(event) => {
                          const selectedValues = event.target.value.map(String);
                          field.onChange(selectedValues);
                        }}
                        value={field.value || []}
                        sx={{
                          minHeight: '2rem',
                          // height: '1.6rem',
                          fontSize: '0.75rem',
                          '& .MuiSelect-select': {
                            padding: '0 8px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                          },
                        }}
                      >
                        {categoryList.map((option) => (
                          <MenuItem key={option.id} value={option.id.toString()}
                            sx={{
                              p: '.5rem',
                              minHeight: '0',
                              '& .MuiCheckbox-root': {
                                // Control Checkbox size
                                transform: 'scale(0.7)', // Adjust scale as needed
                                padding: '0'
                              },
                              '& .MuiListItemText-primary': {
                                // Control ListItemText size
                                fontSize: '0.75rem',
                              }
                            }}
                          >
                            <Checkbox checked={field.value.indexOf(option.id.toString()) > -1} />
                            <ListItemText primary={option.title}
                              primaryTypographyProps={{
                                sx: {
                                  fontSize: '0.75rem',
                                  fontWeight: 400
                                }
                              }}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>waive Visit Charge <span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                  name='waiveVisitCharge'
                  control={control}
                  rules={{
                    required: 'enter waive Visit Charge',
                    validate: (value) => {
                      const numValue = parseInt(value, 10);
                      if (isNaN(numValue)) return 'Please enter a valid Amount';
                      if (numValue < 0) return 'Waive Visit Charge should be 0 or greater than 0';
                      if (numValue > 9999) return 'Waive Visit Charge cannot exceed Rs. 9999';
                      return true;
                    }
                  }}
                  defaultValue={[]}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      size='small'
                      fullWidth
                      // sx={{width:{xs:'100%',sm:'auto'}}}
                      error={!!error}
                      type='number'
                      placeholder='0'

                      // Add these props to prevent increment/decrement
                      inputProps={{
                        style: { fontSize: '0.65rem' },
                        onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                        onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                        onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                        onKeyDown: (e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }
                      }}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                          // field.onChange(formatValue(inputValue));
                          let finalValue = formatValue(inputValue);

                          // Check if the value exceeds 10000 and constrain it
                          const numValue = parseFloat(finalValue);
                          if (!isNaN(numValue) && numValue > 9999) {
                            finalValue = '9999';
                          }

                          field.onChange(finalValue);
                        }
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* description */}
          <Grid item xs={12}>
            <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Description </Typography>
            <Controller
              name='description'
              control={control}
              rules={{ 
                validate: (value) => {
                  if(value){
                    const words = value?.trim().split(/\s+/);
                    if (words.length > 100) {
                      return 'Please enter a description with 100 words or less';
                    }
                  }
                  return true;
                }
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  size='small'
                  fullWidth
                  multiline
                  rows={3}
                  // sx={{width:{xs:'100%',sm:'auto'}}}
                  inputProps={{
                    style: { fontSize: '0.65rem' },
                  }}
                  error={!!error}
                  placeholder='Enter description (upto 100 words)'
                  // onChange={(event) => {
                  //   const words = event.target.value.trim().split(/\s+/);
                  //   if (words.length > 5) {
                  //     event.target.value = event.target.value.substring(0, event.target.value.lastIndexOf(' '));
                  //   }
                  // }}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

export default BasicInfo;
